import GoogleLoginComponent from './GoogleLogin'
import MobileLogin from './MobileLogin'
import UserLogin from './UserLogin'
import React, { useState } from 'react'
import { setAppToken, cookieValues, setBaseUrl } from './login.service.js'
import PropTypes from 'prop-types'
import styles from './../styles.module.css'

export const ChaloReactHybridLogin = ({
  onLoginResponse,
  hasMobileLogin,
  hasUserLogin,
  hasGoogleLogin,
  hasResetPw,
  googleProperties,
  cookieKeys
}) => {
  const [showGoogleLogin, setShowGoogleLogin] = useState(true)
  const [loginType, setLoginType] = useState(-1)
  const [isBack, setisBack] = useState(false)
  if (googleProperties.google.clientId && googleProperties.google.clientSecret && googleProperties.google.redirectUri) {
    setAppToken(googleProperties.google.clientId, googleProperties.google.clientSecret, googleProperties.google.redirectUri)
  } else {
    window.alert('Please provide app clientId and clientSecret and RedirectUri')
    return
  }
  if(cookieKeys.loginState && cookieKeys.user){
    cookieValues(cookieKeys.loginState,cookieKeys.user)    
  }

  if(googleProperties.auth.baseUrl){
    setBaseUrl(googleProperties.auth.baseUrl)
  }

  const onLoginSuccess = (data) => {
    onLoginResponse({ code: 'Success', data })
  }

  const onBack = () => {
    setShowGoogleLogin(true)
    setLoginType(-1)
    window.location.reload()
  }

  const toggleLogin = (id) => {
    setShowGoogleLogin(false)
    setLoginType(id)
  }

  const onBackFromUser = (data) => {
    setisBack(data)
  }

  return (
    <div>
      <div className={styles.sign_in_wrapper}>
        <div className={styles.header}>
          {(!showGoogleLogin || isBack) && (
            <div className={styles.back} onClick={onBack} />
          )}
          <div className={styles.chalo_logo} />
        </div>
        {showGoogleLogin && (
          <div>
            {!isBack && (
              <div className={styles.sign_in_text}>
                Welcome! Sign in to your account
              </div>
            )}
            {isBack && (
              <div className={styles.sign_in_text}>
                Please reset your password
              </div>
            )}
            {hasUserLogin && (
              <div>
                <UserLogin
                  onLoginSuccess={onLoginSuccess}
                  onBackFromUser={onBackFromUser}
                  hasResetPw={hasResetPw}
                />
                {((!isBack && hasGoogleLogin != false) || (hasMobileLogin)) && (
                  <h2 className={styles.divider}>
                    <span className={styles.divider_text}>Or</span>
                  </h2>
                )}
              </div>
            )}
            <div>
              {!isBack && hasGoogleLogin != false && (
                <GoogleLoginComponent onLoginSuccess={onLoginSuccess} googleProperties={googleProperties}/>
              )}
              {hasMobileLogin && !isBack && (
                <div
                  className={styles.google_sign_in_wrapper}
                  onClick={() => toggleLogin(2)}
                >
                  <div className={styles.otp_logo} />
                  <div className={styles.google_sign_in_text}>
                    Sign In with OTP
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {!showGoogleLogin && hasMobileLogin && loginType === 2 && (
          <div>
            <MobileLogin onLoginSuccess={onLoginSuccess} />
          </div>
        )}
      </div>
    </div>
  )
}

ChaloReactHybridLogin.propTypes = {
  onLoginResponse: PropTypes.func.isRequired,
  hasMobileLogin: PropTypes.bool,
  hasUserLogin: PropTypes.bool,
  hasGoogleLogin: PropTypes.bool,
  googleProperties:PropTypes.object.isRequired,
  cookieKeys:PropTypes.object.isRequired
}
